// The camera presets, kept apart from the viewer itself.
//
// The controls around the canvas need these names and labels, but importing them from SetupViewer
// would drag three.js into the main bundle and undo the lazy split — 600 KB downloaded by every
// user of the app to render six buttons.
export const SETUP_VIEWS = ['front', 'right', 'left', 'upper', 'lower', 'angle'] as const;
export type SetupViewAngle = (typeof SETUP_VIEWS)[number];

export const SETUP_VIEW_LABELS: Record<SetupViewAngle, string> = {
  front: 'Front',
  right: 'Right',
  left: 'Left',
  upper: 'Upper',
  lower: 'Lower',
  angle: '3/4',
};
